<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-button type="success" @click="fnAdd">添加类别</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="otherproducttypelisttable" :url-func="$http.getTypeList">
        <el-table-column label="类别名称" prop="name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <div v-if="row.classification != 'system'">
              <el-button type="warning" size="small" @click="fnAdd(row)">编辑</el-button>
              <el-button type="danger" size="small" @click="fnDelete(row)">删除</el-button>
            </div>
            <span v-else>系统定义无法修改</span>
          </template>
        </el-table-column>

      </wq-table>
      <el-dialog
        title="添加/编辑类别"
        :visible.sync="bShowDialog"
      >
        <form-box key="consumeform" label-width="120px" :forms="addForms" :post-form="addPostForm" @submit="fnSubmitAdd" />
      </el-dialog>
    </div>

  </div>

</template>
<script>

import FormBox from '@/components/FormBox'
import WqTable from '@/components/WqTable'

const defaultAddForm = {
  id: '',
  name: ''
}

export default {
  name: 'OtherType',
  components: {
    // Select
    WqTable,
    FormBox
  },

  data() {
    return {
      lists: [],
      tableKey: 0,
      addPostForm: Object.assign({}, defaultAddForm),
      bShowDialog: false,
      addForms: [{ type: 'input', bindValue: 'name', label: '类别名称', require: true }]
    }
  },
  created() {

  },
  methods: {
    fnAdd(row) {
      this.addPostForm = Object.assign({}, row || defaultAddForm)
      this.bShowDialog = true
    },
    fnSubmitAdd(postForm) {
      this.$http.improveType(postForm).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.bShowDialog = false
          this.$refs.otherproducttypelisttable.fetchTableData()
        }
      })
    },
    fnDelete(row) {
      this.$confirm(`是删除<${row.name}>类型么？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteType({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.$refs.otherproducttypelisttable.fetchTableData()
          }
        })
      }).catch(() => {

      })
    }

  }
}
</script>
  <style lang="scss">
  .el-image-viewer__wrapper .el-icon-circle-close {
    color:white
  }
    .food-search {
    .tuolele-main-search-item {
      margin-bottom: 0;
      padding: 0;
      border: 0;
      .el-form--inline .el-form-item {
        display: block;
      }
      .split-time{
        margin-right: 20px;
      }
      .el-select,
      .el-input {
        width: 160px !important;
        margin-right: 20px;
      }
      span.select-date {
        margin-right: 10px;
      }
      .button-group {
        margin-left: 82px;
      }
    }
  }
  </style>
